<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">
      <h2 class="ficha-title" :style="styles.colorBasic">Datos Generales</h2>
     
      <article class="group">
        <div class="contenedor-data w-100" v-if="!!data.idOferta">
          <h4 class="data-title" :style="styles.colorBasic">Id Práctica</h4>
          <p>{{data.idOferta}}</p>
        </div>
         
        <div class="contenedor-data" v-if="!!data.fechaAlta">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de Alta</h4>
          <p>{{data.fechaAlta}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.fechaFin">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de fin</h4>
          <p>{{data.fechaFin}}</p>
        </div>
        <template v-if="data.contactos">
          <h2 class="ficha-title" :style="styles.colorBasic">Contactos</h2>
          <section class="contact-section" v-for="(el,key) in data.contactos">
            <div class="contenedor-data" v-if="!!el.nombre">
              <h4 class="data-title" :style="styles.colorBasic">Nombre</h4>
              <p>{{el.nombre}}</p>
            </div>
          
            <div class="contenedor-data" v-if="!!el.apellidos">
              <h4 class="data-title" :style="styles.colorBasic">Apellidos</h4>
              <p>{{el.apellidos}}</p>
            </div>
          
            <div class="contenedor-data" v-if="!!el.puesto">
              <h4 class="data-title" :style="styles.colorBasic">Puesto</h4>
              <p>{{el.puesto}}</p>
            </div>
          
            <div class="contenedor-data" v-if="!!el.nombre">
              <h4 class="data-title" :style="styles.colorBasic">Teléfono</h4>
              <p><a :href="`tel:${el.telefono}`">{{el.telefono}}</a></p>
            </div>
          
            <div class="contenedor-data" v-if="!!el.nombre">
              <h4 class="data-title" :style="styles.colorBasic">Email</h4>
              <p><a :href="`mailto:${el.email}`">{{el.email}}</a></p>
            </div>
          
          </section>
        </template>
      </article>
    </template>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {
      
    },
    methods: {
      

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand: 'getBrand'
      }),

    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion
    }

  }
</script>

<style scoped lang="scss">
 .contact-section{
  display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #dedede;
    margin-bottom: 15px;
    padding-bottom: 15px;
 }

 .ficha-title{
  width: 100% !important;
  margin-top: 5px;
 }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-datos-generales.vue